import { useFormikContext } from 'formik';
import { useMemo } from 'react';

import type { Asset2ReviewStatus, Asset2TranscodingStatus, Maybe, RejectionReason } from '../../../../apis/graphql';
import { useCalculatedCreativeData } from '../../../../hooks/useCalculatedCreativeData';
import type { LineItemModel } from '../../../../pages/Trafficking/TraffickingPage/modelConverters';
import { getAdCountryListForReview } from '../../../../utils/reviewDerivation';
import type { AdFormValues } from '../../adFormik';
import type { CreativesBuilderValues } from '../types';

export type UseCalculatedCreativeDataByAdCountriesResult = {
  derivedCreativeReviewStatus?: Asset2ReviewStatus;
  derivedCreativeTranscodingStatus?: Maybe<Asset2TranscodingStatus>;
  rejectionReasons?: RejectionReason[];
  loading: boolean;
};

export const useCalculatedCreativeDataByAdCountries = (
  creative: CreativesBuilderValues,
  lineItem?: Pick<LineItemModel, 'country' | 'countries' | 'displayPublisherTarget'>,
  skip?: boolean
): UseCalculatedCreativeDataByAdCountriesResult => {
  const { values } = useFormikContext<AdFormValues>();
  const countryList = useMemo(
    () => getAdCountryListForReview(values.lineItem?.countries, values.targetingTermValues ?? []),
    [values.lineItem?.countries, values.targetingTermValues]
  );

  const { calculatedCreativeData, loading } = useCalculatedCreativeData({
    creative,
    publisherList: lineItem?.displayPublisherTarget ?? [],
    countryList,
    skip,
  });

  return {
    derivedCreativeReviewStatus: calculatedCreativeData?.status,
    derivedCreativeTranscodingStatus: calculatedCreativeData?.transcodingStatus,
    rejectionReasons: calculatedCreativeData?.rejectionReasons,
    loading,
  };
};
